const _ = require('lodash');

function attribute(key) {
  return _.get(window.stentInschrijvenTheaterauditie, key);
}

function config(key = null) {
  if (key !== null) {
    return attribute(`config.${key}`);
  }

  return attribute('config');
}

function scrollIntoView(target, options = {}) {
  let element = document.querySelector(target);

  if (element !== null) {
    element.scrollIntoView({ behavior: 'smooth', ...options });
  }
}

function setAllObjectProperties(object, value) {
  for (let index in object) {
    if (object.hasOwnProperty(index)) {
      object[index] = value;
    }
  }

  return object;
}

function setAllObjectPropertiesToArray(object) {
  return setAllObjectProperties(object, []);
}

function formatUserUploadIdentifier(user) {
  return `${user.id};${user.email}`;
}

function isEmptyObject(obj){
  return JSON.stringify(obj) === '{}';
}

function allObjectValuesEmptyArray(object) {
  for (var i in object) {
    if (object[i].length !== 0) {
      return false;
    }
  }

  return true;
}

function fileListToArray(fileList) {
  return Array.prototype.slice.call(fileList);
}

function removeFromArrayByIndex(array, index) {
  if (index > -1) {
    array.splice(index, 1);
  }
}

export default {
  attribute,
  config,
  scrollIntoView,
  setAllObjectProperties,
  setAllObjectPropertiesToArray,
  formatUserUploadIdentifier,
  isEmptyObject,
  allObjectValuesEmptyArray,
  fileListToArray,
  removeFromArrayByIndex,
};
